import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'quotes/quoteItemComponents/purchasedComponentsDrawer/CLOSE',
  FETCH_SMART_MATCHES_ERROR:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/FETCH_SMART_MATCHES_ERROR',
  FETCH_SMART_MATCHES_REQUEST:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/FETCH_SMART_MATCHES_REQUEST',
  FETCH_SMART_MATCHES_SUCCESS:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/FETCH_SMART_MATCHES_SUCCESS',
  OPEN: 'quotes/quoteItemComponents/purchasedComponentsDrawer/OPEN',
  SAVE_COMPONENT_ERROR:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SAVE_COMPONENT_ERROR',
  SAVE_COMPONENT_REQUEST:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SAVE_COMPONENT_REQUEST',
  SAVE_COMPONENT_SUCCESS:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SAVE_COMPONENT_SUCCESS',
  SAVE_COMPONENT_AND_LINK_PRODUCT:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SAVE_COMPONENT_AND_LINK_PRODUCT',
  SET_ACTIVE_TAB:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SET_ACTIVE_TAB',
  SEARCH_SELECT_PURCHASED_COMPONENT:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SEARCH_SELECT_PURCHASED_COMPONENT',
  SEARCH_SET_OVERRIDE_SEARCH_TERM:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SEARCH_SET_OVERRIDE_SEARCH_TERM',
  SMART_MATCH_SELECT_PRODUCT:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SMART_MATCH_SELECT_PRODUCT',
  SMART_MATCH_SELECT_PURCHASED_COMPONENT:
    'quotes/quoteItemComponents/purchasedComponentsDrawer/SMART_MATCH_SELECT_PURCHASED_COMPONENT',
};

export const fetchSmartMatches = {
  error: notify(
    (error) => ({
      type: types.FETCH_SMART_MATCHES_ERROR,
      payload: error,
    }),
    'Failed to load smart match recommendations. You can still manually convert to a purchased component.',
  ),
  request: () => ({
    type: types.FETCH_SMART_MATCHES_REQUEST,
  }),
  success: ({ products, purchasedComponents }) => ({
    type: types.FETCH_SMART_MATCHES_SUCCESS,
    payload: { products, purchasedComponents },
  }),
};

export const purchasedComponentsDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: ({ componentId, mode, quoteItemId }) => ({
    type: types.OPEN,
    payload: {
      componentId,
      mode,
      quoteItemId,
    },
  }),
  setActiveTab: ({ tab }) => ({
    type: types.SET_ACTIVE_TAB,
    payload: { tab },
  }),
};

export const saveComponent = {
  error: notify(
    (error) => ({
      type: types.SAVE_COMPONENT_ERROR,
      payload: error,
    }),
    'Failed to save changes.',
  ),
  request: ({ purchasedComponentId }) => ({
    type: types.SAVE_COMPONENT_REQUEST,
    payload: { purchasedComponentId },
  }),
  success: () => ({
    type: types.SAVE_COMPONENT_SUCCESS,
  }),
  linkProduct: ({ purchasedComponentId, productId }) => ({
    type: types.SAVE_COMPONENT_AND_LINK_PRODUCT,
    payload: { purchasedComponentId, productId },
  }),
};

export const search = {
  setOverrideSearchTerm: ({ overrideSearchTerm }) => ({
    type: types.SEARCH_SET_OVERRIDE_SEARCH_TERM,
    payload: { overrideSearchTerm },
  }),
};

export const smartMatch = {
  selectProduct: ({ productId }) => ({
    type: types.SMART_MATCH_SELECT_PRODUCT,
    payload: { productId },
  }),
  selectPurchasedComponent: ({ hasProduct, purchasedComponentId }) => ({
    type: types.SMART_MATCH_SELECT_PURCHASED_COMPONENT,
    payload: { hasProduct, purchasedComponentId },
  }),
};
